import React, {useContext, useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarNavMenu from "../../components/SidebarNavMenu";
import SidebarItem from "../../../SidebarItem";

import list from "api/option/list";

import {ReactComponent as DataIcon} from "assets/img/data-2.svg";

import {getTranslation} from "domain/helpers/translations";

import {sortOn} from "utils/sortOn";
import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function OptionItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    const [formattedOptions, setFormattedOptions] = useState([]);

    const hasOptionManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_OPTION_MANAGEMENT);

    useEffect(() => {
        if (!hasOptionManagementAuthorization) {
            return;
        }

        list('mapped=true').then((response) => {
            const formattedOptions = response.map((option) => ({
                id: option.id,
                name: getTranslation(option).name,
                position: option.position
            }));

            formattedOptions.sort(sortOn('position'));

            setFormattedOptions(formattedOptions);
        })
    }, [hasOptionManagementAuthorization]);

    if (!hasOptionManagementAuthorization) {
        return null;
    }

    return (
        <SidebarNavMenu
            selected={currentPath === MarketplaceRoutes.OPTIONS}
            open={currentPath.startsWith(MarketplaceRoutes.OPTION)}
            icon={<DataIcon />}
            content={<FormattedMessage id='sidebar.item.options' />}
            to={MarketplaceRoutes.OPTIONS}
        >
            {formattedOptions.map((option) => (
                <SidebarItem
                    key={option.id}
                    to={MarketplaceRoutes.OPTION_BY_ID(option.id)}
                    selected={currentPath.startsWith(MarketplaceRoutes.OPTION_BY_ID(option.id))}
                >
                    {option.name}
                </SidebarItem>
            ))}
        </SidebarNavMenu>
    );
}

export default OptionItem;
